<template>
  <div class="row columns">
    <div class="large-12">
      <div v-if="$store.getters.detailedRoster">
        <div class="row columns">
          <div class="large-12 inner-title">
            Gestion des anciens Joueurs:
          </div>
          <div class="large-12 inner-subtitle">
            Choisissez les joueurs que vous voulez garder, et virez les autres.
            Par défaut, tous les joueurs sont gardés
          </div>
        </div>
        <table>
          <thead>
          <tr class="">
            <th width="60">n</th>
            <th width="150">Nom</th>
            <th width="100">Position</th>
            <th width="10">M</th>
            <th width="10">F</th>
            <th width="10">Ag</th>
            <th width="10">Ar</th>
            <th width="250">Compétences</th>
            <th with="20">Départ</th>
            <th width="50">Nb Saisons</th>
            <th width="100">Cout de réachat</th>
            <th width="20"></th>
          </tr>
          </thead>
          <tbody class="roster" v-if="team">
          <tr v-for="p of team.players" :class="[canRemovePlayerFromRevokeList(p.id) ? 'barre' : '','']">
            <td>{{p.num}}</td>
            <td>{{p.name}}</td>
            <td>{{p.ref_roster_line}}</td>
            <td>{{p.M}}</td>
            <td>{{p.F}}</td>
            <td>{{p.Ag}}</td>
            <td>{{p.Ar}}</td>
            <td>
               <span v-for="skill of p.skills">
                  {{skill.name}},
               </span>
              <span v-if="p.upgrades.length" v-for="up in p.upgrades" :class="getUpgradeStyle(up)" >
                                        {{getUpgradeName(up)}},
                                     </span>
              <span v-if="p.downgrades" class="upgrade down">
                                        {{getDowngrades(p)}},
                                     </span>
              <div v-if="p.customizations && p.customizations.length" v-for="cust in p.customizations" class="upgrade stats">
                <span v-if="cust.skills" v-for="skill in cust.skills">{{skill.name}}, </span>
              </div>
            </td>
            <td>{{is_leaving(p.id)}}</td>
            <td>{{played_seasons(p.id)}}</td>
            <td>{{formerPlayerCost(p.id)}} 000</td>
            <td class="action">
              <button :id="p.id" @click="removePlayerFromRevokeList(p.id)"
                      :class="[canRemovePlayerFromRevokeList(p.id) ? '' : 'deactivated', 'small action']"
                      :disabled="canRemovePlayerFromRevokeList(p.id) === false">
                <span><i class="fa fa-shopping-cart" aria-hidden="true"></i></span>
              </button>
            </td>
            <td class="action">
              <button :id="p.id" @click="addPlayerToRevokeList(p.id)"
                :class="[canAddPlayerToRevokeList(p.id) ? '' : 'deactivated', 'small alert action']"
                :disabled="canAddPlayerToRevokeList(p.id) === false">
                <span><i class="fa fa-trash-o" aria-hidden="true"></i></span>
              </button>
            </td>
          <tr>
            <td colspan="9" class="sous-total right">Budget Anciens Joueurs</td>
            <td class="sous-total"></td>
            <td class="sous-total">{{totalPlayerCost}} 000 pO</td>
            <td colspan="2">pour {{totalHiredPlayer}} joueurs</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'formerPlayerChooser',
  components: {
  },
  props: {
    team: {},
    baseChosenLines: {}
  },
  data () {
    return {
      playerToRevoke: []
    }
  },
  computed:
  {
    getLineCount: function () {
      var vm = this
      return function (line) {
        if (vm.playerList[line.id]) {
          return vm.playerList[line.id]
        }
        return 0
      }
    },
    totalHiredPlayer: function () {
      console.log(this.$store.getters.detailedTeam)
      if (!this.$store.getters.detailedTeam || !this.$store.getters.detailedTeam.players) {
        return 0
      }
      return this.$store.getters.detailedTeam.players.length - this.playerToRevoke.length
    },
    totalPlayerCost: function () {
      if (this.$store.getters.detailedTeam === null || this.playerToRevoke === null) {
        return 0
      }
      let cost = 0
      this.$store.getters.detailedTeam.players.forEach(p1 => {
        let found = this.playerToRevoke.find(p2 => {
          return p1.id === p2
        })
        if (found === undefined) {
          cost += this.formerPlayerCost(p1.id)
        }
      })
      return cost
    }
  },
  methods: {
    getRosterLineforPlayer (player) {
      let foundPlayer = this.$store.getters.detailedTeam.players.find(p => {
        return p.id === player
      })
      let rosterName = foundPlayer.ref_roster_line
      console.log('rostername')
      console.log(rosterName)
      if (!this.$store.getters.detailedRoster.roster_lines) {
        return undefined
      }
      let foundRl = this.$store.getters.detailedRoster.roster_lines.find(rl => {
        return rl.position === rosterName
      })
      console.log('foundRl')
      console.log(foundRl)
      return foundRl
    },
    formerPlayerCost (playerId) {
      if (this.$store.getters.detailedTeam === null ||
        this.$store.getters.detailedTeam.players === null ||
        this.$store.getters.seasonBreakInfos === null
      ) {
        return 0
      }
      let foundPlayer = this.$store.getters.detailedTeam.players.find(p => {
        return p.id === playerId
      })
      let playerSbi = this.$store.getters.seasonBreakInfos.players.find(psbi => {
        return psbi.player.id === playerId
      })
      let isLeavingOffset = 0
      if (playerSbi.is_leaving) {
        isLeavingOffset = 20 * (playerSbi.played_seasons + playerSbi.custom.custom_played_seasons)
      }
      return foundPlayer.base_cost + foundPlayer.evolution_cost + isLeavingOffset
    },
    is_leaving (playerId) {
      if (this.$store.getters.seasonBreakInfos === null) {
        return 'non'
      }
      let playerSbi = this.$store.getters.seasonBreakInfos.players.find(psbi => {
        return psbi.player.id === playerId
      })
      if (playerSbi.is_leaving) {
        return 'Oui'
      }
      return 'Non'
    },
    played_seasons (playerId) {
      if (this.$store.getters.seasonBreakInfos === null) {
        return 0
      }
      let playerSbi = this.$store.getters.seasonBreakInfos.players.find(psbi => {
        return psbi.player.id === playerId
      })
      return playerSbi.played_seasons + playerSbi.custom.custom_played_seasons
    },
    getUpgradeName (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 0 || upgrade.value === 1) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
    },
    getUpgradeStyle (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
        if (upgrade.value === 1) {
          return 'upgrade double'
        }
        if (upgrade.value > 1) {
          return 'upgrade stats'
        }
      }
    },
    getDowngrades (player) {
      if (player.downgrades === null) {
        return ''
      }
      let dwngrd = ''
      if (player.downgrades['M'] !== 0) {
        dwngrd += '-' + player.downgrades['M'].toString(10) + 'M '
      }
      if (player.downgrades['F'] !== 0) {
        dwngrd += '-' + player.downgrades['F'].toString(10) + 'F '
      }
      if (player.downgrades['Ag'] !== 0) {
        dwngrd += '-' + player.downgrades['Ag'].toString(10) + 'Ag '
      }
      if (player.downgrades['Ar'] !== 0) {
        dwngrd += '-' + player.downgrades['Ar'].toString(10) + 'Ar '
      }
      return dwngrd
    },
    // ajoute un joueur du type qui va bien
    addPlayerToRevokeList: function (formerPlayer) {
      this.playerToRevoke.splice(0, 0, formerPlayer)
    },
    // enlève un joueur du type qui va bien
    removePlayerFromRevokeList (playerToRevoke) {
      this.playerToRevoke.splice(this.playerToRevoke.findIndex(p2 => playerToRevoke === p2), 1)
    },
    countHiredPlayerOfType (rosterLineId) {
      // si pas de team détaillées,
      if (!this.$store.getters.detailedTeam) {
        return 0
      }
      // on cherche les joueurs du type qui ne sont pas revokés
      let revokedPlayerOfType = this.playerToRevoke.filter(ptr => {
          // est ce qu'il y a des joueurs revokés de ce type
        return rosterLineId === this.getRosterLineforPlayer(ptr).id
      }).length
      let hiredPlayerOfType = this.$store.getters.detailedTeam.players.filter(p => {
        return rosterLineId === this.getRosterLineforPlayer(p.id).id
      }).length

      return hiredPlayerOfType - revokedPlayerOfType
    },
    // peut-on enlever (reengager) un joueur ?
    canRemovePlayerFromRevokeList: function (playerToRevoke) {
      // avant de savoir si on peut reengager un joueur, il faut vérifier les quotas de positionnels
      let rosterLine = this.getRosterLineforPlayer(playerToRevoke)
      if (rosterLine) {
        let hiredPlayerOfType = this.countHiredPlayerOfType(rosterLine.id)
        let alreadyChosenOfType = this.baseChosenLines[rosterLine.id]
        if ((alreadyChosenOfType + hiredPlayerOfType) >= rosterLine.max) {
          return false
        }
      }
      if (this.playerToRevoke === null || this.playerToRevoke.length === 0) {
        return false
      }
      let found = this.playerToRevoke.find(p2 => playerToRevoke === p2)
      return found !== undefined
    },
    // peut-on ajouter un joueur ?
    canAddPlayerToRevokeList: function (playerToRevoke) {
      if (this.playerToRevoke === null || this.playerToRevoke.length === 0) {
        return true
      }
      let found = this.playerToRevoke.find(p2 => playerToRevoke === p2)
      return found === undefined
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

.starbox {
  margin-bottom: 0;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}



.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}
.upgrade {
  font-weight: 600;
}

.base {
  color: #1a6b3a
}

.simple {
  color: #000000
}

.double {
  color: #0e648e
}

.stats {
  color: #882e8e
}

.down {
  color: #8e2625
}

.small {
  margin-right: 0.3rem;
}

.med-size {
  font-size: 1rem;
}
button.action {
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 0.8rem;
  font-weight: 600
}

  tr.barre {
    text-decoration:line-through;
  }

</style>



// WEBPACK FOOTER //
// former-player-chooser.vue?ffd92624